import { Injectable } from '@angular/core';
import { SERVER_URL } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiConfig {
  public URL_API = SERVER_URL + '';
}
